import type { FaireProductEntity } from "../../entity_types/product";

export const p_88fvx8exzx: FaireProductEntity = {
  token: "p_88fvx8exzx",
  type: "product",
  name: "Sophie La Girafe White Box- Classic",
  brandToken: "b_6diqgb3p",
  brandName: "Sophie la Girafe by Calisson Toys.",
  imageUrl: "https://cdn.faire.com/fastly/c808e1fbae188c99ff0d4f11ad1db3085fef9bf0fec7a5f0ca369bfc2a5bb1cf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c37e388aa439a8b777ab726f1da9937ce628edebc6d6ab62d537ddb749c67b84.png",
    "https://cdn.faire.com/fastly/ee2443dda892018a0d9178fb74de4b71f748d0bb1407481790e2930be806dc14.jpeg",
    "https://cdn.faire.com/fastly/6b709912cae6575202e79cb2816e5ee9c98fd7182accb8e456253802bac0d192.jpeg",
    "https://cdn.faire.com/fastly/15cf89ec72c6993b746db741e7653d3f46909803d6e0da6d144d8efa55072eac.jpeg",
    "https://cdn.faire.com/fastly/61e23b51e783e21ab630ee0f0d91d7edd00ea812caba2f73adf2060bc5172f93.jpeg",
    "https://cdn.faire.com/fastly/120b76bd8d2f5a809911409a41a53566ebd10ddcfd5fe4cc8cae5afc7763ae92.jpeg",
    "https://cdn.faire.com/fastly/7a5e656057bcf60181e2c89b3c2b9bf85f353cd6f1a58d3dd9a63225d227f509.jpeg"
  ],
  priceDollars: 16,
  description: "Sophie la girafe, the most beloved teether for over 60 years!\n𝐒𝐢𝐠𝐡𝐭:\nThe dark and contrasting spots all over sophie la girafe’s body provide visual stimulation and make her easily recognizable to baby. She soon becomes a familiar and reassuring object.\n𝐇𝐞𝐚𝐫𝐢𝐧𝐠:\nHer squeaker keeps baby amused, stimulates his hearings, and helps him to understand the link between cause and effect.\n𝐓𝐚𝐬𝐭𝐞:\nSophie la girafe is very flexible and has lots of parts for baby to chew (ears, horns, legs). She is perfect when teething and is completely safe. Made of natural rubber.\n𝐓𝐨𝐮𝐜𝐡:\nSophie la girafe is perfect for baby’s small hands. She is very light and her long legs and neck are easy for baby to grip. She is very soft to touch, just like baby’s mummy, stimulating soothing physiological and emotional.\n• We enforce our MAP Policy for Sophie la girafe. MAP Price $31.99\n   Imported",
  tags: [],
  msrpDollars: 31.99,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-10-07T18:31:39.786Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
